<template>
  <div
    :class="$style.compatibilitySection"
  >
    <h5 :class="$style.compatibilityNotesHeader">
      {{ compatibilityNotes.header }}
    </h5>
    <p
      v-for="(line,index) in compatibilityNotes.text"
      :key="index"
    >
      <MarkdownInline
        :mdTemplate="line"
      />
    </p>
    <a
      :class="$style.compatibilityNotesLink"
      :href="compatibilityNotes.kbLink.href"
      target="_blank"
    >
      {{ compatibilityNotes.kbLink.text }}
    </a>
  </div>
</template>
<script>

import { MarkdownInline } from '@jumpcloud/ui-components';

export default {
  name: 'CompatibilityNotes',

  components: {
    MarkdownInline,
  },

  props: {
    compatibilityNotes: {
      type: Object,
      required: true,
      validator(value) {
        if (!value) {
          return true;
        }

        return !!(value.header && value.text && value.kbLink
          && value.kbLink.text && value.kbLink.href);
      },
    },
  },
};
</script>
<style module>
@value (gradientLight3) from '~css/colors.css';

.compatibilitySection {
  background-color: gradientLight3;
  border-radius: 7px;
  padding: 15px;
}

.compatibilityNotesHeader.compatibilityNotesHeader {
  font-weight: 700;
  margin-top: 0;
}
</style>
